import React from 'react'

const Sidebar = ({
  backgroundColor,
  displayName,
}) => {
  const showInactivity = !displayName
  return (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="446" height="557" viewBox="0 0 446 617">
    <defs>
        <filter id="a" width="160.8%" height="135.7%" x="-30.4%" y="-19.6%" filterUnits="objectBoundingBox">
            <feOffset dy="5" in="SourceAlpha" result="shadowOffsetOuter1"/>
            <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="20"/>
            <feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"/>
            <feMerge>
                <feMergeNode in="shadowMatrixOuter1"/>
                <feMergeNode in="SourceGraphic"/>
            </feMerge>
        </filter>
        <path id="c" d="M0 4.995A4.992 4.992 0 0 1 5.003 0h349.994A5.004 5.004 0 0 1 360 4.995V62H0V4.995z"/>
        <filter id="b" width="120.3%" height="217.7%" x="-10.1%" y="-52.4%" filterUnits="objectBoundingBox">
            <feOffset dy="4" in="SourceAlpha" result="shadowOffsetOuter1"/>
            <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="11.5"/>
            <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
        </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
        <g filter="url(#a)" transform="translate(44 35)">
            <path fill="#FFF" d="M0 11.003C0 5.478 4.487 1 10.004 1h339.992C355.52 1 360 5.477 360 11.003v516.494c0 5.525-4.487 10.003-10.004 10.003H10.004C4.48 537.5 0 533.023 0 527.497V11.003z"/>
            <g transform="translate(0 444)">
              <rect width="360" height="91.5" fill="#FFF" rx="5"/>
            </g>
            <use fill="#000" filter="url(#b)" xlinkHref="#c"/>
            <use fill={`#${backgroundColor}`} xlinkHref="#c"/>
            <g transform="translate(12 13)">

                <text fill="#FFF" font-family="var(--main-font-family)" fontSize="12" fontWeight="400" opacity=".6">
                    <tspan x="59" y="34">Online Now</tspan>
                </text>
                <circle cx="51" cy="30" r="3.5" fill="#13CB6E" stroke="#FFF"/>
                { displayName && <text fill="#FFF" font-family="var(--main-font-family)" fontSize="15" fontWeight="400">
                    <tspan x="47" y="16">{displayName}</tspan>
                </text> }
                { showInactivity && <rect width="84.7" height="14" x="55" y="215" fill="#CEE1F7" rx="5"/> }
                <path fill="#FFF" d="M327.222 17.25l7.076 7.077a.687.687 0 1 1-.971.972l-7.077-7.077-7.077 7.077a.684.684 0 0 1-.971 0 .687.687 0 0 1 0-.972l7.076-7.077-7.076-7.076a.687.687 0 1 1 .971-.973l7.077 7.077 7.076-7.077a.688.688 0 0 1 .972.973l-7.076 7.076z" opacity=".6"/>
                <g fill="#FFF" opacity=".6" transform="translate(281 15)">
                    <circle cx="18.5" cy="2.5" r="2.5"/>
                    <circle cx="10.5" cy="2.5" r="2.5"/>
                    <circle cx="2.5" cy="2.5" r="2.5"/>
                </g>
            </g>
        </g>
        { displayName && <text fill="#9A9A9A" font-family="var(--main-font-family)" fontSize="12" fontWeight="bold" transform="translate(44 35)">
          <tspan x="76" y="243">{displayName}</tspan>
      </text> }
        { showInactivity && <rect width="84.7" height="14" x="100" y="50" fill="#CEE1F7" rx="5" opacity="0.4"/>}
        <path fill="#F8F8F8" d="M106 308c0-11.046 8.955-20 19.997-20h136.006c11.044 0 19.997 8.944 19.997 20v5c0 11.046-8.955 20-19.997 20H116c-5.522 0-9.999-4.48-9.999-10v-15zM106 351c0-5.522 4.478-10 10.003-10h103.99c11.05 0 20.007 8.944 20.007 20v5c0 11.046-8.948 20-20.007 20h-93.986c-11.05 0-20.007-8.944-20.007-20v-15z"/>
        <text fill="#000" font-family="var(--main-font-family)" fontSize="15" transform="translate(44 35)">
            <tspan x="76" y="281">Hey! No problem at all.</tspan>
        </text>
        <text fill="#000" font-family="var(--main-font-family)" fontSize="15" transform="translate(44 35)">
            <tspan x="76" y="333">How can I help?</tspan>
        </text>
        <path fill={`#${backgroundColor}`} d="M175 175.996c0-11.043 8.948-19.996 19.993-19.996h171.014c11.042 0 19.993 8.958 19.993 19.996v41.008c0 11.043-8.948 19.996-19.993 19.996H194.993C183.951 237 175 228.042 175 217.004v-41.008z"/>
        <text fill="#FFF" font-family="var(--main-font-family)" fontSize="15" transform="translate(44 35)">
            <tspan x="148" y="146">Hi there! I’m interested in </tspan> <tspan x="148" y="166">learning more about your </tspan> <tspan x="148" y="186">product.</tspan>
        </text>
        <g transform="translate(61 123)">
            <rect width="58" height="16" x="134" fill="#CEE1F7" rx="5"/>
            <path fill="#ECF5FF" d="M0 386c0-5.523 4.467-10 10.01-10h306.98c5.528 0 10.01 4.475 10.01 10v11c0 5.523-4.467 10-10.01 10H10.01C4.482 407 0 402.525 0 397v-11z"/>
            <rect width="43" height="16" y="417" fill="#CEE1F7" rx="5"/>
        </g>
    </g>
  </svg>
  )
}
export default Sidebar
